import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { ALL } from "../../consts/strings";

import { filterValueSelector } from "../../reducers/filters/selectors";
import { palette } from "../../theme/palette";

import { Text } from "../Base";
import { View } from "../View";
import { FilterButton } from "./FilterButton";

const useStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "0.938rem",
    paddingBottom: "0.5rem",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  title: {
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1.25rem",
    color: palette.sunburst,
  },
});

export const FilterSection = ({ filter, disabled, onChange }) => {
  const styles = useStyles();
  const selectedValue = useSelector(filterValueSelector(filter.field));

  useEffect(() => {
    disabled && onChange({ ...filter, ...filter.values[0] });
  }, [filter, disabled, onChange]);

  const handleOnClick = useCallback(
    (item) => onChange({ ...filter, ...item }),
    [filter, onChange]
  );

  return (
    <View className={styles.section}>
      <Text className={styles.title}>{filter.title}</Text>
      <View className={styles.content}>
        {filter.values.map((item) => (
          <FilterButton
            key={item.label + item.value}
            onClick={() => handleOnClick(item)}
            active={
              (!!!selectedValue && item.label === ALL) ||
              selectedValue?.value === item.value
            }
            disabled={disabled}
          >
            {item.label}
          </FilterButton>
        ))}
      </View>
    </View>
  );
};

export default FilterSection;
